import enLang from "./entries/en_US";
import zhLang from "./entries/zh_CN";
import arLang from "./entries/ar_AR";
import jaLang from "./entries/ja_JP";

const AppLocale = {
  en: enLang,
  zh: zhLang,
  ar: arLang,
  ja: jaLang,
};

export default AppLocale;
